const autoColumnSize = {
    size: -1,
    minSize: -1,
};

export { autoColumnSize };
//# sourceMappingURL=autoColumnSize.js.map
